import { Controller } from "@hotwired/stimulus"

// Content Review Panel application steps (TMS-1704).
//
// Conditional fields: a `reveal` target names the input that controls it and the
// space-separated values that show it (data-reveal-name / data-reveal-value). It is
// shown while a checked radio or checkbox with that name has one of those values, and
// its fields are disabled while hidden so they are not submitted.
//
// Link repeater: rows are cloned from the `linkTemplate` up to `maxLinks`, after which
// the add button goes quiet.
export default class extends Controller {
  static targets = ["reveal", "links", "linkTemplate", "addLink"]
  static values = { maxLinks: Number }

  connect() {
    this.sync()
    this.syncLinks()
  }

  sync() {
    this.revealTargets.forEach((target) => {
      const { revealName, revealValue } = target.dataset
      const values = revealValue.split(" ")
      const shown = Array.from(this.element.querySelectorAll(`input[name="${revealName}"]`))
        .some((input) => input.checked && values.includes(input.value))

      target.hidden = !shown
      target.querySelectorAll("input, textarea, select").forEach((field) => {
        field.disabled = !shown
      })
    })
  }

  addLink() {
    if (!this.hasLinksTarget || this.linkRows().length >= this.maxLinksValue) return

    const row = this.linkTemplateTarget.content.firstElementChild.cloneNode(true)
    this.linksTarget.appendChild(row)
    row.querySelector("input")?.focus()
    this.syncLinks()
  }

  removeLink(event) {
    event.currentTarget.closest("[data-link-row]")?.remove()
    this.syncLinks()
  }

  syncLinks() {
    if (!this.hasAddLinkTarget) return

    const full = this.linkRows().length >= this.maxLinksValue
    this.addLinkTarget.disabled = full
    this.addLinkTarget.setAttribute("aria-disabled", full)
  }

  linkRows() {
    return this.hasLinksTarget ? this.linksTarget.querySelectorAll("[data-link-row]") : []
  }
}
